/* eslint-disable multiline-ternary */
import React from 'react'
import { Grid, Divider, Hidden } from '@mui/material'
import Tabs from './tabs'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  tabs: {
    flex: 1
  },
  tab: {
    textTransform: 'none',
    fontSize: '1rem'
  },
  divider: {
    marginBottom: spacing(2)
  },
  filterBar: {
    marginBottom: spacing(4)
  }
}))

const TabbedPanel = ({
  labels,
  value,
  onChange,
  filterBar,
  disabled,
  actions,
  children
}) => {
  const classes = useStyles()

  return (
    <Grid
      container
      direction='column'
      spacing={1}
      className={classes.root}
      data-test='tabbed-panel-container'
    >
      <Grid container item alignItems='baseline' spacing={3}>
        <Grid item className={classes.tabs}>
          <Tabs
            value={value}
            disabled={disabled}
            onChange={onChange}
            labels={labels}
            variant='scrollable'
            classes={{ indicator: classes.indicator }}
          />
          <Divider variant='fullWidth' className={classes.divider} />
        </Grid>
        {actions && (
          <Hidden smDown>
            <Grid item>{actions}</Grid>
          </Hidden>
        )}
      </Grid>
      {filterBar}
      {actions && (
        <Hidden smUp>
          <Grid item>{actions}</Grid>
        </Hidden>
      )}
      {children}
    </Grid>
  )
}

export default TabbedPanel
